import { styles } from 'consts';
import styled from 'styled-components';

const { white, progressBarFill, greenSecondary, fontMontserrat, disabledMask } = styles;

interface IProps {
  isSelected: boolean;
  isDisabled: boolean;
  preSelected?: boolean;
}

const setCursor = ({ isDisabled }: IProps) => (isDisabled ? 'not-allowed' : 'pointer');
const setMask = ({ isDisabled }: IProps) => (isDisabled ? disabledMask : 'transparent');
const setBoxShadow = (p: IProps) => (p.isSelected ? 0 : `0 0.0625rem 0.125rem 0 rgba(0, 0, 0, 0.22)`);
const setBorder = ({ isSelected }: IProps) => (isSelected ? `0.125rem solid ${greenSecondary}` : 0);

export const Container = styled.div<IProps>`
  display: flex;
  flex-direction: column;
  flex-basis: 33.33%;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.25rem 0.75rem;
  cursor: ${setCursor};
  box-sizing: border-box;

  &.bank-item__preselected {
    padding: 0.5rem 0 1.375rem;
    width: 100%;

    .image__container {
      width: 9.25rem;
      height: 6.25rem;
    }

    .image__description {
      display: none;
    }

    .image__wrapper {
      width: 9rem;
      height: 6rem;
      border: 0.125rem solid ${greenSecondary};
      padding: 1rem 1rem;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }

  @media (min-width: 550px) {
    flex-basis: 25%;
  }
  @media (min-width: 676px) {
    flex-basis: 20%;
  }
  @media (min-width: 768px) {
    flex-basis: 33.33%;
  }
  @media (min-width: 931px) {
    flex-basis: 25%;
  }

  @media (min-width: 1024px) {
    padding: 0 0.25rem;
    height: 5.2875rem;
    &.bank-item__preselected {
      height: inherit;
    }
  }
`;

export const ImageWrapper = styled.div<IProps>`
  width: 100%;
  height: 3.9375rem;
  padding: 0.7rem 0.5rem;
  box-sizing: border-box;
  border-radius: 0.1875rem;
  background-color: ${white};
  box-shadow: ${setBoxShadow};
  border-radius: 0.1875rem;
  border-width: 0;
  transition: border 200ms ease-in-out;
  position: relative;
  border: ${setBorder};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;

  .disabled__mask {
    background: ${setMask};
    border-radius: 0.1875rem;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    cursor: ${setCursor};
  }

  img {
    max-width: 100%;
    max-height: 100%;
  }
  @media (min-width: 931px) {
    height: 3.6875rem;
  }
`;

export const Description = styled.div`
  width: 5rem;
  height: 1.35rem;
  padding-top: 0.25rem;
  font-family: ${fontMontserrat};
  font-size: 0.436875rem;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${progressBarFill};
  display: none;

  @media (min-width: 1024px) {
    display: block;
  }
`;
